export default __webpack_public_path__ + "media/images/home/slide_primary_2025_lg-6770b9cb7b6156586f17135718341079.jpg";